import { FormattedPDSPeriod } from '../job/Patient';
import { isBefore, isSame } from './dateTime';

type SortReturnValue = 1 | -1 | 0;

export const sortByPeriod = (a: FormattedPDSPeriod, b: FormattedPDSPeriod): SortReturnValue => {
    const periodA = a.period;
    const periodB = b.period;

    if (periodA && !periodB) {
        return -1;
    }

    if (!periodA && periodB) {
        return 1;
    }

    if (!periodA || !periodB) {
        return 0;
    }

    const startEarlier = isBefore(periodA.start, periodB.start) ? -1 : 1;

    if (periodA.end && periodB.end) {
        const endsLater = isBefore(periodA.end, periodB.end) ? 1 : -1;

        return isSame(periodA.end, periodB.end) ? startEarlier : endsLater;
    }

    if (periodA.end && !periodB.end) {
        return 1;
    }

    if (!periodA.end && periodB.end) {
        return -1;
    }

    return startEarlier;
};
